import { Stack, Typography } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import dayjs from "dayjs";
import { TFunction } from "i18next";
import {
	ThirdPartySitesPageDTO,
	ThirdPartySitesPageItemDTO,
} from "../../../../../datasources/api-client/data-contracts";

export const getRows = (data: ThirdPartySitesPageDTO, t: TFunction) => {
	if (!data) return [];

	return data.items.map((item: ThirdPartySitesPageItemDTO) => {
		const safeNumber = (val: any): number => {
			if (val === null || val === undefined || val === "" || isNaN(Number(val))) {
				return 0;
			}
			return Number(val);
		};

		return {
			id: item.id,
			emission: item.sourceLabel,
			startDate: dayjs(item.from).format("DD/MM/YYYY"),
			endDate: dayjs(item.to).format("DD/MM/YYYY"),
			methodology: item.methodologyLabel,
			isCertified: item.isCertified,
			sitesNumber: safeNumber(item.sitesNumber),
			emissions: item.emissions ? safeNumber(item.emissions.value) : 0,
		};
	});
};

export const colsData = (t: TFunction): GridColDef[] => [
	{
		field: "id",
		headerName: "ID",
		flex: 0.7,
		hideable: true,
		renderCell: (params) => (
			<Stack height="100%" alignItems="start" justifyContent="center">
				<Typography variant="body2">{params.value}</Typography>
			</Stack>
		),
	},
	{
		field: "emission",
		headerName: "emission",
		flex: 1,
		hideable: true,
		renderCell: (params) => (
			<Stack height="100%" alignItems="start" justifyContent="center">
				<Typography variant="body2">{params.value}</Typography>
			</Stack>
		),
	},
	{
		field: "startDate",
		headerName: "Start",
		hideable: true,
		flex: 1,
		renderCell: (params) => {
			return (
				<Stack height="100%" alignItems="start" justifyContent="center">
					<Typography variant="body2">{params.value}</Typography>
				</Stack>
			);
		},
	},
	{
		field: "endDate",
		headerName: "End",
		hideable: true,
		flex: 1,
		renderCell: (params) => {
			return (
				<Stack height="100%" alignItems="start" justifyContent="center">
					<Typography variant="body2">{params.value}</Typography>
				</Stack>
			);
		},
	},
	{
		field: "methodology",
		headerName: "methodology",
		flex: 1,
		hideable: true,
		renderCell: (params) => (
			<Stack height="100%" alignItems="start" justifyContent="center">
				<Typography variant="body2">{params.value}</Typography>
			</Stack>
		),
	},
	{
		field: "isCertified",
		headerName: "isCertified",
		flex: 1,
		hideable: true,
		renderCell: (params) => (
			<Stack height="100%" alignItems="start" justifyContent="center">
				<Typography variant="body2">{params.value ? t("yes") : t("no")}</Typography>
			</Stack>
		),
	},
	{
		field: "sitesNumber",
		headerName: "sitesNumber",
		flex: 1,
		hideable: true,
		renderCell: (params) => (
			<Stack height="100%" alignItems="flex-end" justifyContent="center">
				<Typography variant="body2">{params.value}</Typography>
			</Stack>
		),
	},
	{
		field: "emissions",
		headerName: "emissions",
		flex: 1,
		hideable: true,
		renderCell: (params) => (
			<Stack height="100%" alignItems="flex-end" justifyContent="center">
				<Typography variant="body2">{params.value}</Typography>
			</Stack>
		),
	},
];

// Measure map for the columns
const UNIT_BY_FIELD: Record<string, string> = {
	emissions: "tCO2e",
};

export const getColumns = (dataCol: GridColDef[], t: TFunction, headerTextColor: string) =>
	dataCol.map((col, index) => {
		const label = col.headerName ? t(`${col.headerName}`) : "";
		return {
			...col,
			headerName: label,
			renderHeader: () =>
				label && (
					<Stack direction="column" width="100%">
						<Stack
							justifyContent={index === 5 || index === 6 ? "right" : "start"}
							alignContent="start"
							flexDirection="row"
							alignItems="baseline"
						>
							<Typography fontWeight={700} sx={{ color: headerTextColor }} variant="body2">
								{label}
							</Typography>

							<Typography fontWeight={700} sx={{ color: headerTextColor }} variant="caption" ml={0.5}>
								{UNIT_BY_FIELD[col.field]}
							</Typography>
						</Stack>
					</Stack>
				),
		};
	});
